'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _reduceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/reduce');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var informant_interface = require('./informant.interface.js');
var lodash = require('lodash');
var groupBy_enum = require('../time-series/group-by.enum.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _reduceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_reduceInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);

var InformantServices = ['GSE', 'GPE', 'RESTPP', 'GSQL', 'GUI'];
var InformantMetricType = /*#__PURE__*/function (InformantMetricType) {
  InformantMetricType["CPU"] = "cpu";
  InformantMetricType["MEMORY"] = "memory";
  InformantMetricType["DISK_SPACE"] = "diskSpace";
  InformantMetricType["SERVICE_STATE"] = "serviceState";
  InformantMetricType["QPS"] = "qps";
  return InformantMetricType;
}({});
var Informant = {
  cpu: {
    URL: '/api/informant/metrics/get/cpu-memory',
    name: 'cpu',
    metricName: 'CPUMemoryMetrics'
  },
  memory: {
    URL: '/api/informant/metrics/get/cpu-memory',
    name: 'mem',
    metricName: 'CPUMemoryMetrics'
  },
  diskSpace: {
    URL: '/api/informant/metrics/get/diskspace',
    name: 'diskspace',
    metricName: 'DiskMetrics'
  },
  serviceState: {
    URL: '/api/informant/service-status-history',
    name: 'servicestate',
    metricName: 'ServiceStatusEvents'
  },
  qps: {
    URL: '/api/informant/metrics/get/qps',
    name: 'qps',
    metricName: 'QPSMetrics'
  }
};
var InformantMetricLogic = /*#__PURE__*/function () {
  function InformantMetricLogic() {
    _classCallCheck__default["default"](this, InformantMetricLogic);
  }
  return _createClass__default["default"](InformantMetricLogic, null, [{
    key: "convertCPU",
    value:
    /**
     * Convert the CPU metrics from the Informant endpoint to the visual data points.
     *
     * @param metrics CpuMemoryMetric Array.
     * @returns Ts3RecordEntry Array.
     */
    function convertCPU(metrics) {
      var entries = [];
      _forEachInstanceProperty__default["default"](metrics).call(metrics, function (metric) {
        // Skip if one of the required fields is undefined.
        if (!metric.ServiceDescriptor || !metric.HostID || !metric.CollectTimeStamps || !metric.CPU || !metric.CPU.CPUUsage) {
          return;
        }

        // TODO: Support more services in the future.
        if (!_includesInstanceProperty__default["default"](InformantServices).call(InformantServices, metric.ServiceDescriptor.ServiceName)) {
          return;
        }
        entries.push({
          detail: metric.CPU.CPUUsage,
          when: lodash.toInteger(metric.CollectTimeStamps / 10e8),
          where: metric.HostID,
          who: metric.ServiceDescriptor.ServiceName,
          what: Informant[InformantMetricType.CPU].name
        });
      });
      return entries;
    }

    /**
     * Convert the Memory metrics from the Informant endpoint to the visual data points.
     *
     * @param metrics CpuMemoryMetric Array.
     * @returns Ts3RecordEntry Array.
     */
  }, {
    key: "convertMemory",
    value: function convertMemory(metrics) {
      var entries = [];
      _forEachInstanceProperty__default["default"](metrics).call(metrics, function (metric) {
        // Skip if one of the required fields is undefined.
        if (!metric.ServiceDescriptor || !metric.HostID || !metric.CollectTimeStamps || !metric.Memory || !metric.Memory.MemoryUsageMB) {
          return;
        }

        // TODO: Support more services in the future.
        if (!_includesInstanceProperty__default["default"](InformantServices).call(InformantServices, metric.ServiceDescriptor.ServiceName)) {
          return;
        }
        entries.push({
          detail: metric.Memory.MemoryUsageMB,
          when: lodash.toInteger(metric.CollectTimeStamps / 10e8),
          where: metric.HostID,
          who: metric.ServiceDescriptor.ServiceName,
          what: Informant[InformantMetricType.MEMORY].name
        });
      });
      return entries;
    }

    /**
     * Convert the DiskSpace metrics from the Informant endpoint to the visual data points.
     *
     * @param metrics DiskMetric Array.
     * @returns Ts3RecordEntry Array.
     */
  }, {
    key: "convertDisk",
    value: function convertDisk(metrics) {
      var entries = [];
      _forEachInstanceProperty__default["default"](metrics).call(metrics, function (metric) {
        // Skip if one of the required fields is undefined.
        if (!metric.HostID || !metric.CollectTimeStamps || !metric.Disk || !metric.Disk.Path || !metric.Disk.SizeMB || !metric.Disk.PathName) {
          return;
        }
        entries.push({
          detail: {
            disk: '',
            free: '',
            path: metric.Disk.Path,
            size: metric.Disk.SizeMB
          },
          when: lodash.toInteger(metric.CollectTimeStamps / 10e8),
          where: metric.HostID,
          who: metric.Disk.PathName,
          what: Informant[InformantMetricType.DISK_SPACE].name
        });
      });
      return entries;
    }

    /**
     * Convert the ServiceStatus metrics from the Informant endpoint to the visual data points.
     *
     * @param metrics ServiceStateMetric Array.
     * @returns Ts3RecordEntry Array.
     */
  }, {
    key: "convertServiceStatus",
    value: function convertServiceStatus(metrics, startTime, endTime) {
      var entries = [];
      _forEachInstanceProperty__default["default"](metrics).call(metrics, function (metric) {
        // Skip if one of the required fields is undefined.
        if (!metric.ServiceDescriptor || !metric.HostId || !metric.EventMeta || !metric.ServiceStatus || !metric.EventMeta.TimestampNS) {
          return;
        }
        if (!metric.ServiceDescriptor.ServiceName) {
          return;
        }
        entries.push({
          detail: informant_interface.ServiceState[metric.ServiceStatus] ? informant_interface.ServiceState[metric.ServiceStatus] : 0,
          when: lodash.toInteger(metric.EventMeta.TimestampNS / 10e8),
          where: metric.HostId,
          who: metric.ServiceDescriptor.ServiceName,
          what: Informant[InformantMetricType.SERVICE_STATE].name
        });
      });
      return InformantMetricLogic.postProcessServiceStatus(entries, startTime, endTime);
    }
  }, {
    key: "convertQPS",
    value: function convertQPS(metrics) {
      return _reduceInstanceProperty__default["default"](metrics).call(metrics, function (res, cur) {
        var _context;
        if (!cur.HostID || !cur.CollectTimeStamps || !cur.QPS) {
          return res;
        }
        var ts3RecordEntry = {
          detail: {
            QPS: cur.QPS.QPS || 0,
            average_latency: cur.QPS.AverageLatencyMS || 0,
            max_latency: cur.QPS.MaxLatencyMS || 0,
            timeout: cur.QPS.TimeoutRequestNum || 0,
            min_latency: cur.QPS.MinLatencyMS || 0
          },
          when: lodash.toInteger(Number(cur.QPS.EndTimestampNS) / 1e9),
          where: cur.HostID,
          who: cur.QPS.Endpoint,
          what: Informant[InformantMetricType.QPS].name
        };
        return _concatInstanceProperty__default["default"](_context = []).call(_context, _toConsumableArray__default["default"](res), [ts3RecordEntry]);
      }, []);
    }
    /**
     * Post-process the service status visual data points.
     *
     * @param entries Ts3RecordEntry[].
     * @param startTime number.
     * @param endTime number.
     * @returns Ts3RecordEntry Array.
     */
  }, {
    key: "postProcessServiceStatus",
    value: function postProcessServiceStatus(entries, startTime, endTime) {
      var _context2, _entries;
      var newEntries = [];

      // handle if input only have metrics with timestamp greater than endTime.
      entries = _filterInstanceProperty__default["default"](entries).call(entries, function (entry) {
        return entry.when <= endTime;
      });
      var machineGroups = lodash.groupBy(entries, groupBy_enum.GroupByKey.Where);
      _forEachInstanceProperty__default["default"](_context2 = _Object$keys__default["default"](machineGroups)).call(_context2, function (machine) {
        var _context3;
        var serviceGroups = lodash.groupBy(machineGroups[machine], groupBy_enum.GroupByKey.Who);
        _forEachInstanceProperty__default["default"](_context3 = _Object$keys__default["default"](serviceGroups)).call(_context3, function (service) {
          var _context4, _context5;
          if (serviceGroups[service].length === 0) {
            return;
          }

          // Find the visual data points with the largest timestamp which is <= end time.
          // Create a new visual data point with the same metric but the end time as its timestamp.
          var maxEndTime = 0;
          var maxEndTimeEntry;
          _forEachInstanceProperty__default["default"](_context4 = serviceGroups[service]).call(_context4, function (entry) {
            if (maxEndTime < entry.when && entry.when <= endTime) {
              maxEndTime = entry.when;
              maxEndTimeEntry = entry;
            }
          });
          var newEntry = lodash.cloneDeep(maxEndTimeEntry);
          newEntry.when = endTime;
          newEntries.push(newEntry);

          // Find the visual data points with the smallest timestamp which is <= start time.
          // Create a new visual data point with the same metric but the start time as its timestamp.
          var maxStartTime = 0;
          var maxStartTimeEntry;
          _forEachInstanceProperty__default["default"](_context5 = serviceGroups[service]).call(_context5, function (entry) {
            if (maxStartTime < entry.when && entry.when <= startTime) {
              maxStartTime = entry.when;
              maxStartTimeEntry = entry;
            }
          });
          if (maxStartTimeEntry) {
            newEntry = lodash.cloneDeep(maxStartTimeEntry);
            newEntry.when = startTime;
            newEntries.push(newEntry);
          }
        });
      });

      // Filter out the visual data points outside the time range.
      entries = _filterInstanceProperty__default["default"](entries).call(entries, function (entry) {
        return startTime < entry.when && entry.when < endTime;
      });
      (_entries = entries).push.apply(_entries, newEntries);
      return entries;
    }
  }]);
}();

exports.Informant = Informant;
exports.InformantMetricLogic = InformantMetricLogic;
exports.InformantMetricType = InformantMetricType;
exports.InformantServices = InformantServices;
